import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const year = get(state, 'innovationByDesign.year');
  let title = `Innovation by Design Awards ${year}`;
  let img = `https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/500/h/400/scale/ibd/ibd-${year}-logo-share.png`;
  let description = '';

  switch (parseInt(year, 10)) {
    case 2017:
      description =
        "Fast Company's sixth annual Innovation By Design Awards are now announced. Read on for this year's " +
        'best products, services, interfaces, and ideas.';
      break;
    case 2018:
      title = 'These are the 397 most inspiring, innovative designs of 2018';
      description =
        'When it comes to solving problems, these trailblazing businesses are doing it as simply and as beautifully as possible. Meet the 2018 Innovation by Design honorees.';
      img =
        'https://images.fastcompany.net/image/upload/v1536444678/fcweb/ibd_poster_og_wgggrl.png';
      break;
    default:
      // TODO: This solution is temporary. It needs some work to make sure the text is correct for each year.
      description = `Check out the ${year} Innovation by Design Awards.`;
      break;
  }

  return baseSeoUtil({
    site,
    siteConf,
    title,
    url: `https://www.fastcompany.com/innovation-by-design/${year}`,
    description,
    image: img,
    articleSection: 'Innovation By Design Awards',
    config: state.config
  });
}
